import React, { Fragment } from "react";
import UF_Content from "../../../../nix_components/components/UF_Content";
import data_types from "../../../../nix_components/data/data_types";
import ReorderModal from "../../../../components/modals/ReorderModal";
import Tooltip from "@mui/material/Tooltip/Tooltip";
import { IconButton } from "@mui/material";
import ReorderIcon from "@mui/icons-material/Reorder";
import TransferDataModal from "../../../../components/modals/TransferDataModal";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import TranslateIcon from '@mui/icons-material/Translate';
import SpeakerTranslationsModal from "../../../../components/modals/SpeakerTranslationsModal";

class Speakers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reorderOpen: false,
      transferOpen: false,
      permission: "speaker",
      scopeCondition: false,
      loaded: false,
      setTranslations: false,
      setTranslationsForId: false,
      setTranslationsForName: false,
    };
  }

  buttons = {
    setTranslations: (params) => {
      return (
        <Fragment>
          <IconButton
            aria-label="languages"
            color="default"
            onClick={() => this.setTranslationsState(params.row.id, `${params.row.first_name} ${params.row.last_name}`)}
          >
            <TranslateIcon />
          </IconButton>
        </Fragment>
      )
    }
  };

  setTranslationsState = (speakerId, speakerName) => {
    this.setState({setTranslations: true});
    this.setState({setTranslationsForId: speakerId});
    this.setState({setTranslationsForName: speakerName});
  }

  setTranslations = () => {
    return (
      <SpeakerTranslationsModal 
        open={this.state.setTranslations}
        eventId={this.props.event_id}
        modelId={this.state.setTranslationsForId}
        modelName={this.state.setTranslationsForName}
        onClose={() => this.setState({ setTranslations: false })}
      />
    );
  }
  
  tools = {
    reorder: () => {
      return this.state.scopeCondition ? (
        <Tooltip title={"Reorder"}>
          <IconButton onClick={() => this.setState({ reorderOpen: true })}>
            <ReorderIcon />
          </IconButton>
        </Tooltip>
      ) : null;
    },
    transfer: () => {
      return this.state.scopeCondition ? (
        <Tooltip title={"Transfer"}>
          <IconButton onClick={() => this.setState({ transferOpen: true })}>
            <MoveUpIcon />
          </IconButton>
        </Tooltip>
      ) : null;
    },
  };

  formConfig = {
    rows: [
      [
        // {
        //     label: 'Template Speakers',
        //     field: 'Template Speakers',
        //     // field: 'template_speakers',
        //     datatype: 'template',
        //
        // },
        {
          label: "Published",
          field: "published",
          datatype: data_types.boolean,
        },
      ],
      ["first_name", "last_name"],
      [
        {
          label: "Email",
          field: "email",
          datatype: data_types.string,
        },
        {
          label: "Photo",
          field: "image",
          datatype: data_types.file,
          requirements: { width: 480, height: 480 },
        },
      ],
      [
        "company",
        {
          label: "Job title",
          field: "position",
          datatype: data_types.string,
        },
      ],
      [
        {
          field: "bio",
          label: "Biography",
          datatype: data_types.string,
          multiline: true,
        },
      ],
    ],
  };

  gridProps = {
    fields: ["first_name", "company", "position", "published", "created_at"],
  };

  renderTransferDataModal = () => {
    return (
      <TransferDataModal
        open={this.state.transferOpen}
        onClose={() => this.setState({ transferOpen: false })}
        table={"speakers"}
      />
    );
  };

  fetchData = () => {};

  getFetchData = (fetchData) => {
    this.fetchData = fetchData;
  };

  renderReorderingModal = () => {
    return (
      <ReorderModal
        open={this.state.reorderOpen}
        onClose={() =>
          this.setState({ reorderOpen: false }, () => this.fetchData())
        }
        table={"speakers"}
        onClick={this.fetchData}
      />
    );
  };

  handleBeforeAddNew = (dataItem, callback) => {
    dataItem.event_id = global.UF.event_id;
    global.UF.makeRequest(
      `POST`,
      `/api/get-ordering`,
      { table: "speakers" },
      true,
      (data) => {
        dataItem.ordering = data.body.ordering;
        if (callback) {
          callback();
        }
      },
      (error) => {
        console.error(error);
      },
      true,
      false
    );
  };

  findCurrentPermission = () => {
    const user =
      typeof localStorage.getItem("user") === "string"
        ? JSON.parse(localStorage.getItem("user"))
        : localStorage.getItem("user");
    const scopes = user.hasOwnProperty("scopes")
      ? typeof user.scopes === "string"
        ? JSON.parse(user.scopes)
        : user.scopes
      : null;
    this.state.scopeCondition =
      scopes.findIndex(
        (permission) =>
          permission.split(":")[0] === this.state.permission &&
          permission.includes("write")
      ) > -1;
    this.setState({ loaded: true });
  };

  componentDidMount() {
    this.findCurrentPermission();
  }

  render() {
    return (
      <Fragment>
        {this.state.reorderOpen && this.renderReorderingModal()}
        {this.state.transferOpen && this.renderTransferDataModal()}
        {this.state.setTranslations && this.setTranslations()}
        <UF_Content
          table="speakers"
          id={this.props.event_id}
          permission={"speaker"}
          title="Speakers"
          add={this.state.scopeCondition}
          sync={this.state.scopeCondition}
          export={this.state.scopeCondition}
          buttons={this.buttons}
          edit={this.state.scopeCondition}
          delete={this.state.scopeCondition}
          tools={this.tools}
          fetchData={this.getFetchData}
          formConfig={this.formConfig}
          gridProps={this.gridProps}
          beforeAddNew={this.handleBeforeAddNew}
        />
      </Fragment>
    );
  }
}

export default Speakers;
